import { useEffect } from 'react'
import { startListening } from '@core/Store/listenerMiddleware'
import { clearAllBetSlipItems } from '@mobi/betslip/Store/Bets'
import { showBetSlipClearedToast } from '@core/Areas/BetSlip/helpers/toasts'
import { trackBetSlipClear } from '@core/Areas/BetSlip/analytics'

export const useToastOnClearBetSlipSuccess = (shouldEnable: boolean) => {
  useEffect(() => {
    if (!shouldEnable) return undefined

    const stopListener = startListening({
      actionCreator: clearAllBetSlipItems,
      effect: () => {
        showBetSlipClearedToast()
        trackBetSlipClear()
      },
    })

    return () => {
      stopListener()
    }
  }, [shouldEnable])
}
